let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
/**
 * handleFinishTour
 * @param exit
 * @param tourGroup
 */
function handleFinishTour(exit = true, tourGroup = 'tour') {
  return __awaiter(this, void 0, void 0, function*() {
    if (this._globalFinishCallback)
      try {
        yield this._globalFinishCallback()
      } catch (e) {
        return false
      }

    // WARNING: code commented due to handle storage finish save on handleClose!
    // if (this.options.completeOnFinish) {
    //   if (!localStorage.tg_tours_complete) {
    //     localStorage.tg_tours_complete = [tourGroup]
    //     if (exit) yield this.exit()
    //     this.activeStep = 0
    //     return
    //   }
    //   const storageTours = localStorage.tg_tours_complete.split(',')
    //   storageTours.push(tourGroup)
    //   localStorage.tg_tours_complete = storageTours
    // }

    if (exit) yield this.exit()
    this.activeStep = 0
    return true
  })
}
/**
 * getIsFinished
 * @param tourGroup
 */
function getIsFinished(tourGroup = 'tour') {
  if (!localStorage.tg_tours_complete) {
    return false
  }
  const storageTours = localStorage.tg_tours_complete.split(',')
  return storageTours.includes(tourGroup)
}
function delFinishedTour(tourGroup = 'tour') {
  if (tourGroup === 'all') {
    localStorage.tg_tours_complete = null
    return
  }
  const storageTours = localStorage.tg_tours_complete.split(',')
  localStorage.tg_tours_complete = storageTours.filter(x => {
    return x !== tourGroup
  })
}
export default handleFinishTour
export { getIsFinished, delFinishedTour }
